import { CSSProperties, ReactNode } from 'react';
import { useSSRSelector } from 'src/redux';
import { RootState } from 'src/redux/reducers';

export interface MediaContainerProps extends CSSProperties {
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  isSelected?: boolean;
  containerClasses?: string;
  children: ReactNode | undefined;
}

export function MediaContainer(props: MediaContainerProps) {
  const {
    onClick = null,
    onMouseEnter = null,
    onMouseLeave = null,
    isSelected = false,
    containerClasses = '',
    width = null,
    height = null,
    borderWidth = 0.6,
    borderColor = '#858585',
    children,
  } = props;

  const {
    theme: {
      product_aspect_ratio: aspectRatio = 100,
      product_base_image_color: backgroundColor = '#FFFFFF',
    },
  } = useSSRSelector((state: RootState) => ({
    theme: state.storeReducer.store.theme,
  }));

  function getDimensions() {
    return {
      ...(width ? { width } : {}),
      ...(height ? { height } : {}),
    };
  }

  return (
    <div
      className={`relative tw-flex tw-items-center tw-justify-center  tw-overflow-hidden ${containerClasses}`}
      style={{
        ...getDimensions(),
        borderStyle: isSelected ? 'solid' : 'none',
        borderWidth,
        borderColor,
        aspectRatio: aspectRatio / 100,
        backgroundColor,
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
}
